import * as React from 'react';

interface ShowAsDollarsProps {
  number: number;
}

export function ShowAsDollars(props: ShowAsDollarsProps) {
  if(props.number) {
    return(<h3 className="text-lg">${Math.round(props.number)}</h3>)
  }
  return null;
}
